import { OrganizationPlaceApi } from "../types";

export const Permission = {
	DEFAULT: "DEFAULT",
	USERS_MANAGMENT: "USERS_MANAGMENT",
};
export const allPermissions = () => {
	return Object.keys(Permission);
};
// export string[] permissions = [
//     {value: 'USERS_MANAGMENT', label: 'USERS_MANAGMENT'}
// ];
export interface OrganizationUserApi {
	id: number;
	email: string;
	name: string;
	applications: InvitationApplicationApi[];
	permissions: string[];
}

export interface UserWithInviteApi {
	id: string;
	type: string;
	item_id: number;
	name: string;
	email: string;
	applications: InvitationApplicationApi[];
	permissions: string[];
}

export interface InvitationApi {
	id: number;
	organization: InvitationOrganizationApi;
	organization_id: number;
	email: string;
	created_at: string;
	updated_at: string;
	status: string;
	user_id: number;
	user?: InvitationUserApi;
	applications: InvitationApplicationApi[];
	permissions: string[];
}

export interface InvitationOrganizationApi {
	name: string;
	company_id: string;
	place: OrganizationPlaceApi;
}

export interface InvitationApplicationApi {
	application_type: string;
	role_id: string;
}

export interface InvitationUserApi {
	name: number;
}

// export interface InvitationApi {
//     email: string;
//     permissions: string[];
// }

export interface InviteUserApi {
	email: string;
	permissions: string[];
}

export interface UpdateInvitationApi {
	email: string;
	permissions: string[];
}

export interface CardApi {
	issuer: string;
	mask_number: string;
	validity_year: string;
	validity_month: string;
	expired_at: string;
}

export interface PaymentSourceApi {
	card: CardApi;
	created_at: string;
	status: string;
	reference_id: string;
	error_message: string;
	error_attempt_count: string;
}

export interface OrganizationAlert {
	title: string;
	type?: "DANGER" | "WARNING";
}

export interface OrganizationInvitationLinkApi {
	link: string;
}

export interface SupportAccessFormProps {
	applications: SingleApplicationAccess[];
}

export interface SingleApplicationAccess {
	support_access_to: string;
	id: number;
	permissions: string[];
	user_permissions: string[];
	type: string;
	enable_access: boolean;
}

export type SupportAccessPermissionConfig = {
	type: string;
	permissions: string[];
};

export interface VerifyTermApi {
	terms_name: string;
	terms_url: string;
	signed: boolean;
}
